import { forwardRef } from 'react';
import { useController } from 'react-hook-form';
import { IoLogoUsd } from 'react-icons/io5';

import { NumberInput, NumberInputProps } from '@mantine/core';
import { mergeRefs } from '@mantine/hooks';

import { useReadOnlyPlaceholder } from 'components/forms/fields/hooks/use-readonly-placeholder';

export type PriceFieldProps = NumberInputProps & {
    name: string;
};

const PriceField = forwardRef<HTMLDivElement, PriceFieldProps>(({ name, ...props }: PriceFieldProps, ref) => {
    const {
        field: { onChange, ...field },
        fieldState: { error, isTouched },
    } = useController({ name });

    const placeholderRef = useReadOnlyPlaceholder('Not specified');

    const mergedRef = mergeRefs(ref, placeholderRef);

    return (
        <NumberInput
            {...field}
            {...props}
            ref={mergedRef}
            onValueChange={(values) => {
                onChange(values.floatValue);
            }}
            value={field.value ?? ''}
            error={isTouched && error?.message}
            hideControls
            allowNegative={false}
            decimalScale={2}
            fixedDecimalScale
            thousandSeparator=","
            leftSection={<IoLogoUsd />}
        />
    );
});

PriceField.displayName = 'PriceField';

export { PriceField };
